import React from "react";
import "../styles/Terms.css";

const Terms = () => {
  return (
    <div className="terms-container">
      <h1>Terms & Conditions</h1>
      <p>By using JobsHotSpot, you agree to follow our terms...</p>
    </div>
  );
};

export default Terms;
